import { productFactory } from './product.factory';
import { foodFactory } from './food.factory';
import { dayFactory } from './day.factory';
import { planFactory } from './plan.factory';
import { patientFactory } from './patient.factory';
import { Menu } from '../model/menu.model';
import { Energy } from '../model/energy.model';
import { Schema } from '../model/schema.model';
import { createTimestampFromDateAndTime } from '../utils/dateFormatter';
import {helpers} from "../helpers";

export const menuFactory = {
  create: (response) => {
    const days = [];
    const schema = response.schema;

    const patient = patientFactory.create(
      response.patient.id,
      response.patient.externalId,
      response.patient.name,
      response.patient.lastName,
      response.patient.email,
      response.patient.allergens,
      response.patient.dislikedProducts,
    );

    schema.days.forEach((d) => {
      const day = dayFactory.create(d.id, d.date, d.comment);

      d.plans.forEach((dayPlan) => {
        let foods = [];

        const planDate = createTimestampFromDateAndTime(d.date, dayPlan.time);

        dayPlan.foods.forEach((m) => {
          let products = [];
          m.products.forEach(prod => {
            products.push(productFactory.createFromDto(prod, patient));
          });

          let food = foodFactory.createFromDto(m, patient);
          food.date = planDate;
          foods.push(food);
        });

        let prods = [];
        dayPlan.products.forEach(prod => {
          prods.push(productFactory.createFromDto(prod, patient));
        });
        day.addPlan(planFactory.create(
            dayPlan.id,
            dayPlan.name,
            dayPlan.prescribedEnergy.amount,
            dayPlan.time,
            dayPlan.comment,
            foods,
            prods,
            planDate
        ));
      });

      days.push(day);
    });

    return new Menu(
      response.id,
      patient,
      new Schema(
        new Energy(schema.desiredEnergy.amount),
        schema.comment,
        helpers.deepClone(schema.prescribedNutrients),
        days,
      ),
    );
  },
};
